"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.settings = void 0;
var windowEnv = typeof window !== 'undefined' ? (window._env_ || {}) : {};
var REACT_APP_CDN_DOMAIN = 'https://genesis-cdn.ff.com';
// if cdn is qa or staging, use dev. ff-ui has no qa and staging envs
if (windowEnv.REACT_APP_CDN_DOMAIN === 'https://ff-genesis-cdn-qa.s3.amazonaws.com') {
    REACT_APP_CDN_DOMAIN = 'https://ff-genesis-cdn-dev.s3.us-west-2.amazonaws.com';
}
else if (windowEnv.REACT_APP_CDN_DOMAIN === 'https://ff-genesis-cdn-staging.s3.amazonaws.com') {
    REACT_APP_CDN_DOMAIN = 'https://ff-genesis-cdn-dev.s3.us-west-2.amazonaws.com';
}
else if (windowEnv.REACT_APP_CDN_DOMAIN) {
    REACT_APP_CDN_DOMAIN = windowEnv.REACT_APP_CDN_DOMAIN;
}
exports.settings = {
    FF_ICONS_VERSION: 5,
    REACT_APP_CDN_DOMAIN: REACT_APP_CDN_DOMAIN,
};
